import React from "react";
import PropTypes from "prop-types";
import KpisPerformanceDesktop from "./KpisPerformanceDesktop";

function KpisPerformance({ app, config }) {
  return <KpisPerformanceDesktop app={app} config={config} />;
}

KpisPerformance.defaultProps = {
  app: null,
  config: {},
};

KpisPerformance.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default KpisPerformance;
